<div class="inner-wrapper">
  <div
    *ngIf="video"
    class="player-container"
    app-scroll-to-print
    [doScrollToPoint]="playerService.doScrollToPoint"
    [player]="player">
    <h2 class="u-text-left">{{ video.title }}</h2>
    <app-media-player
      #player
      [video]="video"
      (play)="onPlay()"
      (enterFullscreen)="onEnterFullscreen()"
      (exitFullscreen)="onExitFullscreen()"
      (ready)="onPlayerReady($event)"
      (loadStart)="onLoadstart()"
      (loadedData)="onLoadedData()"
      (loadedMetadata)="onLoadedMetadata()"
      (canPlay)="onCanplay()"
      (stalled)="onStalled()"
      (multimediaError)="onMultimediaError($event)"
      class="player video-loaded">
    </app-media-player>
  </div>
</div>
